import React from 'react';
import { DemoButton, DemoIntroWrapper, ExitButton } from './styles';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import { useDispatch, useI18n } from '~Hooks';
import * as actions from '../../../../actions';
import { useStorage } from '~Components/Storage';

const DemoIntro = () => {
  const { navigateTo } = usePage();
  const dispatch = useDispatch();
  const { i18n } = useI18n();
  const [, updateStorage] = useStorage();

  const exitDemoMode = () => {
    dispatch(actions.setDemoMode(false));
    dispatch({
      type: 'SET_POS_LAYOUT',
      POSLayout: null,
    });
    updateStorage({ hideDemoMode: true });
  };

  return (
    <DemoIntroWrapper>
      <h1>{i18n('DemoMode.Title')}</h1>
      <p>{i18n('DemoMode.Text')}</p>
      <DemoButton onClick={() => navigateTo('ordering')}>
        {i18n('DemoMode.ExploreButton')}
      </DemoButton>
      <ExitButton onClick={exitDemoMode}>{i18n('DemoMode.ExitMode')}</ExitButton>
    </DemoIntroWrapper>
  );
};

export default DemoIntro;
